import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'formly-wrapper-panel',
  template: `
    <div class="passwordCnt">
    <label [for]= "inputId" [id]="'label_' + inputId" *ngIf="to.label && !to.hideLabel">
        {{ to.label }}
        <span class="required-symbol error" *ngIf="to.required && !to.hideRequiredMarker">*</span>
        <a href="javascript:void(0);" [routerLink]="['/forgotPassword']" style="float: right;margin-right: 20px;">Forgot Password?</a>
    </label>
    <ng-container #fieldComponent></ng-container>
    </div>
    <div *ngIf="showError" class="error-wrapper">
        <i class="icon-error" role="presentation"></i>
      <formly-validation-message [field]="field"></formly-validation-message>
    </div>
  `,
})
export class LoginWrapperComponent extends FieldWrapper {
  @ViewChild('fieldComponent', { read: ViewContainerRef })
  fieldComponent!: ViewContainerRef;
  get inputId(): string {
    return this.field.id !== undefined ? this.field.id : '';
  }
}